<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">Billing</h4>
   
                    <button v-if="this.permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadDataBast()">
                      <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} BAST
                    </button>

                    <button v-if="this.permision_role.method_read" class="btn btn-warning float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadDataPi()">
                      <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} PI
                    </button>

                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="list-exim-billing" ref="list-exim-billing"
                    :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                      mode="remote" @on-page-change="onPageChange"
                      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" 
                    @on-selected-rows-change="selectionChanged"
                     
                      @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                      :isLoading.sync="isLoading" :pagination-options="{
                       
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }" :rows="rows" :columns="columns">
   
                        <template slot="column-filter" slot-scope="{ column }">
                            <span v-if="column.filterOptions.customFilter">

                                <span v-if="column.field == 'job_date'">

                                    <date-range-picker style="width:100%" @update="trxDateChange"
                                        control-container-class="form-control"
                                        :locale-data="{ format: 'yyyy-mm-dd' }" v-model="trxDate"
                                        :opens="opens" :singleDatePicker="false" :timePicker24Hour="false"
                                        :timePicker="false" :showWeekNumbers="false">
                                        <div slot="header" slot-scope="header" class="slot">
                                            <a @click="cleartrxDateChange()" class="float-end"
                                                style="margin-right: 5px;color:red;">Clear Calendar</a>
                                            <span v-if="header.in_selection"> - in selection</span>
                                            <br>
                                        </div>
                                    </date-range-picker>

                                </span>

                            </span>

                        </template>
                   
  
                      <template slot="table-row" slot-scope="props">
                        
                            <span v-if="props.column.field == 'actions'">
                            <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="detailData(props.index, props.row)">
                                <i class="mdi mdi-eye" style="font-size:16px;color:#32a852;"></i>
                            </a> 
     
                            
                            </span>
     
    
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                            
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
   

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>



  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';
 

export default {
    name: "EximBillingIndex",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker

    },
    data() {

        return {
  
            opens   : "center",
            locale  : {
                format  : "yyyy-mm-dd",

            },
            trxDate : {
                startDate   : null,
                endDate     : null
            },
            firstDates  : {
                startDate   : null,
                endDate     : null
            },
            highlighted : {

                dates   : [ // Highlight an array of dates
                    new Date(),
                ],

            },
            trxDateFrom     : "",
            trxDateTo       : "",
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            companyCode: "", 
            forms: {master_fr_id:"", product_id:"", product_name:"", create_by:"", update_by:"" , created_at:"", updated_at:""},
            serverParams: {
            columnFilters: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            per_page: 10,
            },
       
            columns: [
    
                {
                    label: "job no",
                    field: "job_no",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "job date",
                    field: "job_date",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: true,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "customer cd",
                    field: "customer_cd",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "customer nm",
                    field: "customer_nm",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: "updated at",
                    field: "updated_at",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: false, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },
            ],
            rows: [],
            rowsSelection: [],
            idCodeLkups: [],
            totalRecords: 0,
        };
    },
    watch: {},
    methods: {
 
        trxDateChange() 
        {

            if (this.trxDate.startDate && this.trxDate.endDate) {
                this.trxDateFrom = this.$moment(String(this.trxDate.startDate)).format('YYYY-MM-DD');
                this.trxDateTo = this.$moment(String(this.trxDate.endDate)).format('YYYY-MM-DD');
                this.loadItems()
            }

        },

        cleartrxDateChange() 
        {
            this.trxDate = {
                startDate: null,
                endDate: null
            };
            this.trxDateFrom = ""
            this.trxDateTo = ""
            this.onColumnFilter({
                    columnFilters: {customer_cd:"",customer_nm:"",job_date:"",job_no:""},
                    page: 1,
                    per_page: 10,
                });
            this.loadItems()
        },

        selectionChanged(ev) {
            this.rowsSelection = [];
            this.idCodeLkups   = [];
            this.rowsSelection = ev.selectedRows;

            this.rowsSelection.forEach((item) => {
                this.idCodeLkups.push(item.exim_bill_header_id);

            });

        },
        
        detailData(index, row) {
    
            var params = this.$onRandom(row.exim_bill_header_id);
            window.location.href = "/billing/exim/transaction/detail/" + params;

        },
 

        downloadDataBast() {
            const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/exim/billing/download-bast";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_BAST_" + CurrentDate + ".zip";
            this.isLoading = true; 

            const exim_bill_header_ids = {
                exim_bill_header_ids:this.idCodeLkups
            };

            return this.$http.post(
                baseURI ,
                exim_bill_header_ids,
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
                
            }).catch((error) => {

                this.isLoading = false;
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
            });

        },



        downloadDataPi() {
            const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/exim/billing/download-pi";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_PI_" + CurrentDate + ".zip";
            this.isLoading = true; 

            const exim_bill_header_ids = {
                exim_bill_header_ids:this.idCodeLkups
            };

            return this.$http.post(
                baseURI ,
                exim_bill_header_ids,
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
                
            }).catch((error) => {

                this.isLoading = false;
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
            });

        },
 

        loadItems() {

            const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/exim/billing/index";
            this.isLoading = true; 

            var job_date = "";

            if (this.trxDateFrom.length > 0 && this.trxDateTo.length > 0) {
                job_date = this.trxDateFrom + '~' + this.trxDateTo
            }

            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&job_no=${this.serverParams.columnFilters.job_no}&customer_cd=${this.serverParams.columnFilters.customer_cd}&customer_nm=${this.serverParams.columnFilters.customer_nm}&job_date=${job_date}`,
                { timeout: 10000 })
                .then((response) => {

                    this.isLoading      = false;
                    this.rows           = response.data.datas.data;
                    this.totalRecords   = response.data.datas.total;

                 }).catch((error) => {
                    
                    this.isLoading      = false;
    
                if (error.code == "ECONNABORTED") {
                    
                    this.error(this.$t("check_internet_connection_txt"));
    
                }else{
    
                    this.isLoading      = false;
                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                        this.logout();
                        } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                        } else {
                        this.$router.push('/page-not-found');
                        }
                    }
    
                }
            });
        },

  
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
  
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
  
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    
   

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'EximBillingController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },


        cek_message(status,msg){
            if(status=='200'){
                this.success(msg);
            }
        },

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();

    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>